<template>
    <div class="posterSetting">
        <el-dialog title="自定义海报" :visible.sync="dialogVisible" width="734px" :before-close="handleClose">
            <p class="tips">点击可编辑，最多添加三张</p>
            <div class="choiceImg">
                <!-- <upload class="headImage" :imgRule="imgRule" ref="coverfile" :uploadType="uploadType" @setImage="getImageUrl"></upload> -->
                <div class="addPoster" @click="addPoster">
                    <i class="el-icon-plus"></i>
                </div>
                <div class="imgBox" v-if="list">
                    <div v-show="index < list" :class="{'item': true, 'select': selectIndex === index}" v-for="(item,index) in img" :key="index" @click="choiceImg(index)">
                        <img :src="item.logoPic.furl + '?' + timestamp" alt="" v-if="item.logoPic.furl + '?' + timestamp">
                        <i class="el-icon-error" @click="deletePoster(item.innerid, index)"></i>
                    </div>
                </div>
            </div>
            <div class="settingBox" v-if="list">
                <div class="settingItem" v-for="(item,index) in img" :key="index" v-show="selectIndex === index">
                    <div class="showImg">
                        <img :src="item.logoPic.furl + '?' + timestamp" alt="" v-if="item.logoPic.furl + '?' + timestamp">
                        <div class="headLogo" v-if="item.headimgformat === '1'">
                            <img src="../../../../../common/images/markeingcenter/head-logo.png" alt="">
                            <p :class="{'c9': item.nicknameformat === '909399', 'cf': item.nicknameformat === 'FFFFFF', 'c4': item.nicknameformat === '409EFF'}">用户昵称</p>
                        </div>
                        <div class="codeStyle">
                            <img src="../../../../../common/images/markeingcenter/code-logo.png" alt="">
                            <!-- <img v-if="item.qrcodestyle" class="fingerprint" src="../../../../../common/images/markeingcenter/fingerprint-logo.png" alt=""> -->
                        </div>
                    </div>
                    <div class="imgSetting">
                        <div class="bgUpload">
                            <div class="title">自定义背景</div>
                            <div class="img">
                                <!-- <uploadFile :uploadType="uploadType" @setFile="setFile" :fileRule="fileRule"></uploadFile> -->
                                <button @click="uploadBtn" class="uploadBtn">上传</button>
                                <!-- <button class="uploadBtn">上传</button> -->
                                <p class="imgTips">建议尺寸750px1334px或9：16， JPG、PNG格式，图片小于1M</p>
                            </div>
                        </div>
                        <div class="avatarShow">
                            <div class="title">用户头像显示</div>
                            <div class="setBox">
                                <div class="showSetting">
                                    <el-radio-group v-model="item.headimgformat">
                                        <el-radio  :label="'1'">显示</el-radio>                                        
                                        <el-radio  :label="'0'">不显示</el-radio>
                                    </el-radio-group>
                                </div>
                                <div class="nicknameColor" v-if="item.headimgformat === '1'">
                                    <div class="title">昵称颜色</div>
                                    <div class="colorChoice">
                                        <el-radio-group v-model="item.nicknameformat">
                                            <el-radio label="909399"><span class="color1"></span></el-radio>
                                            <el-radio label="FFFFFF"><span class="color2"></span></el-radio>
                                            <el-radio label="409EFF"><span class="color3"></span></el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="avatarShow">
                            <div class="title">二维码样式</div>
                            <div class="setBox">
                                <div class="showSetting">
                                    <el-radio-group v-model="item.qrcodestyle">
                                        <el-radio :label="1">样式一</el-radio>
                                        <!-- <el-radio :label="2">样式二</el-radio> -->
                                    </el-radio-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click.native="affirm">确 定</el-button>
            </span>
        </el-dialog>
        <LocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="setFile" :uploadType="uploadType"></LocalCropper>
    </div>
</template>
<script>
import Upload from 'base/upload/upload'
import UploadFile from 'base/upload/uploadFile'
import LocalCropper from './posterLocalCropper'
import {getPosterModelList, addEditPosterModel, deletePosterModel, getDefaultPosterSet} from '@/api/distribution'
import {mapGetters, mapActions} from 'vuex'
import {} from '@/common/js/tools.js'
export default {
    name: 'posterSetting',
    data() {
        return {
            dialogVisible: false,
            timestamp: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE',
                attid: '',
                url: ''
            },
            params: {
                kmcinnerid: '',
                kmctype: ''
            },
            cropperOption: {
                fixedNumber: [750, 1334], // 截图框的宽高比例
                enlarge: 13, // 图片根据截图框输出比例倍数
                autoCropWidth: 56, // 默认生成截图框宽度
                autoCropHeight: 112 // 默认生成截图框高度
            },
            fileRule: {
                btnName: '上传',
                cls: '',
                accept: 'image/png,image/jpeg',
                size: 5,
                width: '750',
                height: '1334'
            },
            list: 0,
            img: [],
            selectIndex: 0
        }
    },
    methods: {
        getImageUrl(img) {
            this.articleData.coverPicture = img
        },
        choiceImg(i) {
            this.selectIndex = i
        },
        addPoster() {
            if (this.list < 3) {
                this.setLoading(true)
                getDefaultPosterSet({
                    data: Object.assign({}, this.params),
                    success: data => {
                        this.setLoading(false)
                        this.list++
                        this.selectIndex = this.list - 1
                        data.data.kmctype = this.params.kmctype
                        data.data.kmcinnerid = this.params.kmcinnerid
                        data.data.logoPic = {}
                        data.data.headimgformat = '1'
                        let arr = data.data.nicknameformat.split(',')
                        data.data.nicknameformat = arr[6]
                        data.data.qrcodestyle = 1
                        data.data.preview = true
                        this.img.push(data.data)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            } else {
                this.$message.warning('最多三张海报哦！')
            }
        },
        handleClose() {
            // this.list = []
            this.img = []
            this.dialogVisible = false
        },
        deletePoster(innerid, index) {
            this.$confirm('确定将该模板删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                if (this.img[index].preview) {
                    this.img.splice(index, 1)
                    this.list--
                    this.selectIndex = this.list - 1
                } else {
                    this.setLoading(true)
                    deletePosterModel({
                        data: Object.assign({}, {innerid}),
                        success: data => {
                            this.setLoading(false)
                            this.$message.success('删除成功')
                            this.getPosterList()
                            this.list--
                            this.selectIndex = this.list - 1
                            console.log(this.selectIndex)
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                }
            }).catch(() => {})
        },
        affirm() {
            if (this.list) {
                if (this.img[this.selectIndex].logoPic.furl) {
                    this.$confirm('确定提交该模板吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this.setLoading(true)
                        let obj = JSON.parse(JSON.stringify(this.img[this.selectIndex]))
                        delete obj.logoPic.type
                        if (obj.headimgformat === '0') {
                            obj.headimgformat = ''
                        }
                        obj.logoPic = JSON.stringify(obj.logoPic)
                        delete obj.base64Img
                        addEditPosterModel({
                            data: Object.assign({}, this.params, obj),
                            success: data => {
                                this.setLoading(false)
                                this.$message.success('保存成功')
                            },
                            error: data => {
                                this.setLoading(false)
                                this.$message.error(data.msg)
                            }
                        })
                    }).catch(() => {})
                } else {
                    this.$message.error('请上传自定义背景')
                }
            } else {
                this.dialogVisible = false
            }
            
        },
        openDialog(v) {
            this.dialogVisible = true
            this.params.kmcinnerid = v.kmcinnerid
            this.params.kmctype = v.kmctype
            this.getPosterList()
        },
        uploadBtn() {
            this.$refs.localCropper.initUploadParam()
            this.$refs.localCropper.openDialog()
        },
        getPosterList() {
            this.setLoading(true)
            getPosterModelList({
                data: Object.assign({}, this.params),
                success: data => {
                    this.setLoading(false)
                    this.list = data.data.length
                    if (this.list) {
                        this.img = data.data
                        this.selectIndex = 0
                        this.img.forEach(obj => {
                            if (obj.headimgformat) {
                                obj.headimgformat = '1'
                            } else {
                                obj.headimgformat = '0'
                            }
                            let arr = obj.nicknameformat.split(',')
                            obj.nicknameformat = arr[6]
                            obj.preview = false
                        })
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        setFile(file) {
            delete file.type
            this.img[this.selectIndex].logoPic = JSON.parse(JSON.stringify(file))
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
    },
    components: {
        Upload, UploadFile, LocalCropper
    }
}
</script>
<style lang="scss">
    .posterSetting{
        .el-dialog{
            .tips{
                color: #909399;
            }
            .choiceImg{
                margin-top: 20px;
                display: flex;
                .addPoster{
                    width: 50px;
                    height: 88px;
                    margin-right: 26px;
                    border: 1px solid #D8DCE6;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    .el-icon-plus{
                        color: #D8DCE6;
                        font-size: 24px;
                    }
                }
                .imgBox{
                    display: flex;
                    .item{
                        width: 50px;
                        height: 88px;
                        position: relative;
                        border: 1px solid #D8DCE6;
                        cursor: pointer;
                        margin-right: 36px;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                        .el-icon-error{
                            position: absolute;
                            top: -8px;
                            right: -8px;
                            font-size: 16px;
                        }
                    }
                    .select{
                        border: 1px solid #409EFF;
                    }
                }
            }
            .settingBox{
                margin-top: 20px;
                padding: 20px 0 20px 20px;
                box-sizing: border-box;
                background: #F0F2F5;
                .settingItem{
                    display: flex;
                    .showImg{
                        width: 264px;
                        height: 470px;
                        background: #fff;
                        position: relative;
                        img{
                            width: 264px;
                            height: 469px;
                        }
                        .headLogo{
                            width: 68px;
                            height: 68px;
                            position: absolute;
                            top: 127px;
                            left: 108px;
                            text-align: center;
                            img{
                                width: 48px;
                                height: 48px;
                            }
                            p{
                                text-align: center;
                            }
                            .c9{
                                color: #909399;
                            }
                            .cf{
                                color: #fff;
                            }
                            .c4{
                                color: #409EFF;
                            }
                        }
                        .codeStyle{
                            text-align: center;
                            position: absolute;
                            bottom: 30px;
                            width: 264px;
                            img{
                                width: 50px;
                                height: 50px;
                            }
                            .fingerprint{
                                margin-left: 40px;
                            }
                        }
                    }
                    .imgSetting{
                        flex: 1;
                        margin-left: 20px;
                        .bgUpload{
                            display: flex;
                            line-height: 32px;
                            color: #606266;
                            .title{
                                width: 84px;
                            }
                            .img{
                                margin-left: 20px;
                            }
                            .uploadBtn{
                                width: 95px;
                                height: 32px;
                                background: #fff;
                                border: 1px solid #C0C4CC;
                                text-align: center;
                                line-height: 32px;
                                outline: none;
                            }
                            .imgTips{
                                color: #909399;
                                font-size: 12px;
                                width: 266px;
                                line-height: 18px;
                            }
                        }
                        .avatarShow{
                            display: flex;
                            margin-top: 30px;
                            .title{
                                width: 84px;
                            }
                            .setBox{
                                margin-left: 20px;
                                .nicknameColor{
                                    display: flex;
                                    margin-top: 28px;
                                    .colorChoice{
                                        .el-radio__input{
                                            position: relative;
                                            top: -8px;
                                        }
                                        .el-radio__label{
                                            position: relative;
                                            top: -2px;
                                            span{
                                                display: inline-block;
                                                width: 20px;
                                                height: 20px;
                                            }
                                            .color1{
                                                background: #909399;
                                            }
                                            .color2{
                                                background: #fff;
                                            }
                                            .color3{
                                                background: #409EFF;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .el-radio__input.is-checked+.el-radio__label{
                            color: #303133;
                        }
                        .el-radio{
                            margin-right: 20px;
                        }
                    }
                }
            }
        }
    }
</style>